// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1ffPc","loaderOuter":"PageOverlayLoader_loaderOuter__3_5LB"};